module.exports = __webpack_public_path__ + "img/Article-image5.2d5a6444.jpg";